import React from 'react';
import WritingDocumentMoneyIcon from '../../assets/icons/WritingDocumentMoneyIcon';

export enum MenuItemKeys {
  DEBTS_NEGOTIATION = 'DEBTS_NEGOTIATION',
}

export type MenuItem = {
  text: string,
  path: string,
  icon?: React.FC<{ className?: string }>,
  external?: boolean,
  key?: MenuItemKeys,
};

export const PORTAL_MENU_ITEMS: MenuItem[] = [
  {
    key: MenuItemKeys.DEBTS_NEGOTIATION,
    text: 'Negociación de deudas',
    icon: WritingDocumentMoneyIcon,
    path: '',
  },
];
